var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mw-login\">\n<div class=\"mw-login-content\">\n<input type=\"text\" name=\"email\" ng-model=\"email\" id=\"user-email\"/>\n<input type=\"text\" name=\"token\" ng-model=\"token\" id=\"user-token\"/>\n<button id=\"sign-in\" type=\"button\" ng-click=\"login()\" id=\"next\">\n<span>Test Sign in</span>\n</button>\n</div>\n</div>\n";
var id1="app/user/test-login.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;